import { Box, useTheme } from "@mui/material"
import usePermissions from "../hooks/auth/usePermissions";
import { StyledActionButton } from "./StyledButton";
import { Permissions } from "../api/dtos";
import { FC } from "react";

interface IGridActionProps {
    editPermission?: Permissions;
    deletePermission?: Permissions;
    editUrl?: string;
    deleteUrl?: string;
}

const GridActions: FC<IGridActionProps> = ({
    editPermission,
    deletePermission,
    editUrl,
    deleteUrl
}) => {
    const theme = useTheme();
    const {data: permissions} = usePermissions();
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: theme.spacing(2)
            }}
        >
            {
                editUrl &&
                (
                    !editPermission ||
                    permissions?.includes(editPermission)
                ) && 
                <StyledActionButton
                    variant="edit"
                    to={editUrl}
                />
            }
            {
                deleteUrl &&
                (
                    !deletePermission ||
                    permissions?.includes(deletePermission)
                ) &&
                <StyledActionButton
                    variant="delete"
                    to={deleteUrl}
                />
            }
        </Box>
    )
}

export default GridActions;